import { useEffect } from 'react';
import { applyTheme, resolveTheme, setForcedTheme } from '@/lib/theme';

/**
 * Forces dark while the component is mounted; restores the user's preference on
 * unmount. Used by /login, /invite, /terms, /privacy and /forgot-password.
 *
 * Two things changed when 'system' was added:
 *
 *   1. It no longer PERSISTS. The old version called setTheme('dark'), which
 *      wrote 'dark' to localStorage — so simply opening /login overwrote a
 *      saved preference, and refreshing there made it permanent. It now applies
 *      without persisting, so the stored preference is never touched.
 *
 *   2. It restores by RE-RESOLVING rather than replaying a captured value. The
 *      old version captured `saved` at mount and replayed it at unmount, which
 *      under 'system' would restore a stale light/dark if the OS changed while
 *      the page was open. resolveTheme() reads the OS at unmount instead.
 *
 * setForcedTheme tells theme.js to ignore OS changes while this is mounted, so
 * the forced dark holds even if the user flips their system appearance.
 */
export function useForceDark() {
  useEffect(() => {
    setForcedTheme('dark');
    applyTheme('dark');
    return () => {
      setForcedTheme(null);
      applyTheme(resolveTheme());
    };
  }, []);
}
